require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-how-long-will-it-take-to-become-a-millionaire.json") })
        }
      }, "path---calculators-how-long-will-it-take-to-become-a-millionaire");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-how-long-will-it-take-to-become-a-millionaire!./.cache/json/calculators-how-long-will-it-take-to-become-a-millionaire.json
// module id = 2001
// module chunks = 231608221292675